<template>
  <div class="relative flex">
    <div class="flex flex-col items-center mr-3">
      <div class="flex items-center justify-center rounded-full">
        <component :is="iconComponent" class="h-6 w-6 font-medium truncate" :class="iconColor" />
      </div>

      <div
        v-if="!isLast"
        class="flex-1 w-0.5 mt-1"
        :class="completed ? 'bg-indigo-600' : 'bg-gray-200 dark:bg-gray-400'"
      />
    </div>

    <div class="flex-1" :class="{ 'pb-6': !isLast }">
      <div class="flex items-center gap-2 select-none group">
        <div
          class="font-medium text-[16px] text-gray-400 "
          :class="{
            'text-gray-900 dark:text-white': current,
          }"
        >
          {{ title }}
        </div>
        <slot name="header-right" :current="current" :completed="completed" />
      </div>

      <div v-if="current" class="mt-2">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, inject, onMounted, ref } from 'vue';
  import { CheckCircleIcon } from '@heroicons/vue/solid';
  import { MinusCircleIcon } from '@heroicons/vue/outline';

  defineProps({
    title: {
      type: String,
      required: true,
    },
  });

  const register = inject('stepperRegister');
  const currentStep = inject('currentStep');
  const stepCount = inject('stepCount');

  const index = ref(-1);

  onMounted(() => {
    index.value = register({});
  });

  const completed = computed(() => index.value < currentStep.value);
  const current = computed(() => index.value === currentStep.value);
  const isLast = computed(() => index.value === stepCount.value - 1);

  const iconComponent = computed(() => {
    if (completed.value) {
      return CheckCircleIcon;
    }

    return MinusCircleIcon;
  });

  const iconColor = computed(() => {
    if (completed.value || current.value) {
      return 'text-indigo-600';
    }

    return 'text-gray-400';
  });
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
</style>
